<template>
  <div class="uploadCredentials">
    <section class="page-content">
      <p class="tip">需提供车主和车辆信息进行ETC设备定制，设备定制后不支持无理由退货。</p>
      <div class="form">
        <p class="label">车主信息</p>
        <p class="line">
          <span>身份证</span>
          <span @click="m_goPages('uploadIDCard')"><span :class="uploadInfo.idcard?'active':''">{{uploadInfo.idcard?'已完善':'待完善'}}</span> <i class="iconfont etc-icon-arrow-right"></i></span>
        </p>
        <p class="label">车辆信息</p>
        <p class="line">
          <span>行驶证</span>
          <span @click="m_goPages('uploadVehicle')"><span :class="uploadInfo.vehicle_license?'active':''">{{uploadInfo.vehicle_license?'已完善':'待完善'}}</span> <i class="iconfont etc-icon-arrow-right"></i></span>
        </p>
      </div>
    </section>
    <section class="page-bottom">
      <button cool-btn :disabled="!uploadInfo.idcard || !uploadInfo.vehicle_license" @click="submitPhoto">提交</button>
      <etc-apply-bottom/>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// components
import EtcApplyBottom from '@/components/etc.applyBottom'
// api
// import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'

// config
// import APP from '@/config/app.config'
import ETC from '@/config/etc.config'
// store
import {mapState, mapMutations} from 'vuex'

export default {
  name: 'uploadCredentials',
  mixins: [FunMixin, BiMixin],
  components: {
    EtcApplyBottom
  },
  data() {
    return {
      uploadInfo: {
        idcard: 0,
        vehicle_license: 0
      }
    }
  },
  computed: {
    ...mapState([
      'currentCard',
      'currentOrder',
      'applyOrderInfo',
      'lastApplyInfo'
    ])
  },
  methods: {
    async submitPhoto() {
      this.m_showLoading()
      try {
        const res = await reconApply.orderSubmitReviewOrder({
          draft_sn_id_card: this.lastApplyInfo.draft_sn.idCard,
          draft_sn_vehicle: this.lastApplyInfo.draft_sn.license
        })
        if (res.review_order.order_sn) {
          this.reqErrMsg = ''
          this.setUserApplyStep(3)
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
          this.m_backHome()
        }
      } catch (e) {
        if (e && e.msg && e.code !== -1) {
          this.m_showConfirm({
            content: e.msg,
            noCancel: true
          })
        }
      } finally {
        this.m_loadingClose()
      }
    },
    ...mapMutations([
      'setCurrentOrder',
      'setUserApplyStep',
      'setLastApplyInfo'
    ])
  },
  async mounted() {
    this.m_showLoading()
    try {
      const res = await reconApply.userGetDraft({
        plate_no: this.currentOrder.plate_no,
        plate_color: this.currentOrder.plate_color + ''
      })
      this.setLastApplyInfo(res)
      if (res.validate_result) {
        this.uploadInfo = res.validate_result
      }
    } finally {
      this.m_loadingClose()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.uploadCredentials {
  @include routeViewMinH(200px);
  .page-content {
    padding: 0 40px;
    .progress-step{
      @extend %flex-space-between;
      padding: 20px 84px;
      height: 20px;
      box-sizing: content-box;
      .step{
        width: 16px;
        height: 16px;
        border-radius: 50%;
        //background-color: $primary-color;
      }
      .dot{
        width: 6px;
        height: 6px;
        border-radius: 50%;
        //background-color: $primary-color;
      }
      .gray{
        background-color: #cccccc;
      }
    }
    header{
      text-align: center;
      font-size: 34px;
      font-weight: bold;
      margin-top: 10px;
    }
    .tip{
      margin-top: 30px;
      background-color: #eeeeee;
      border-radius: 10px;
      font-size: 26px;
      padding: 20px;
      line-height: 40px;
    }
    .form{
      padding-top: 10px;
      .label{
        margin-top: 40px;
        font-size: 28px;
        color: #666666;
        line-height: 40px;
      }
      .line{
        height: 100px;
        border-bottom: 1px solid #eeeeee;
        @extend %flex-space-between;
        font-size: 30px;
        span:first-child{
          font-weight: bold;
        }
        span:last-child{
          color: #cccccc;
          i{
            font-size: 30px;
          }
        }
      }
    }
  }
  .page-bottom {
    padding: 0 55px;
  }
}
</style>
